import React from 'react';
import PropTypes from 'prop-types';
import chevron from '@common/images/chevron.svg';
import chevronDisabled from '@common/images/chevron-disabled.svg';
import { Image } from '@learningblocks/shared-components';
import { Button } from '../Button';

import { useTranslation } from "react-i18next";
import i18next from "i18next";

import UI_ar from "../../../locales/ar/translation.json";
import UI_de from "../../../locales/de/translation.json";
import UI_en from "../../../locales/en/translation.json";
import UI_es from "../../../locales/es/translation.json";
import UI_fr from "../../../locales/fr/translation.json";
import UI_it from "../../../locales/it/translation.json";
import UI_ja from "../../../locales/ja/translation.json";
import UI_ko from "../../../locales/ko/translation.json";
import UI_nl from "../../../locales/nl/translation.json";
import UI_pt from "../../../locales/pt/translation.json";
import UI_tr from "../../../locales/tr/translation.json";
import UI_zh from "../../../locales/zh/translation.json";
import UI_zu from "../../../locales/zu/translation.json";
import UI_vi from "../../../locales/vi/translation.json";
import UI_uk from "../../../locales/uk/translation.json";
import UI_az from "../../../locales/az/translation.json";

import style from './style.module.scss';

export function VagueStepper(props) {

  const translations = {
    ar: UI_ar,
    de: UI_de,
    en: UI_en,
    es: UI_es,
    fr: UI_fr,
    it: UI_it,
    ja: UI_ja,
    ko: UI_ko,
    nl: UI_nl,
    pt: UI_pt,
    tr: UI_tr,
    zh: UI_zh,
    zu: UI_zu,
    vi: UI_vi,
    uk: UI_uk,
    az: UI_az,
  };

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const currentLang = urlParams.get('lng') || "en";
  i18next.addResourceBundle('en', 'translation', translations[currentLang] || UI_en, true, true);

  const {
    t,
    // i18n
  } = useTranslation("translation");

  const underflow = () => props.currentValue === props.min;
  const overflow = () => props.currentValue === props.max;

  const [previsional, setPrevisional] = React.useState(props.currentValue);

  React.useEffect(() => {
    setPrevisional(props.currentValue);
  }, [props.currentValue])

  const validateChange = (new_value) => {
    if (new_value < props.min) {
      props.onChange(props.min);
      setPrevisional(props.min);
    }
    else if (new_value > props.max) {
      props.onChange(props.max);
      setPrevisional(props.max);
    }
    else if (new_value !== "") {
      props.onChange(Math.round(new_value * (1 / props.step)) / (1 / props.step));
      setPrevisional(Math.round(new_value * (1 / props.step)) / (1 / props.step));
    }
  };

  const leftButtonNormal = () => (
    <>
      <Image className={style.stepperVague_chevronLeft} src={chevron} role="presentation" onContextMenu={(e) => { e.preventDefault() }} />
      {props.mobileControls ? <span>{t(`${props.mobileControls.leftText}.string`)}</span> : null}
    </>
  );

  const leftButtonDisabled = () => (
    <>
      <Image className={style.stepperVague_chevronLeft} src={chevronDisabled} role="presentation" onContextMenu={(e) => { e.preventDefault() }} />
      {props.mobileControls ? <span>{t(`${props.mobileControls.leftText}.string`)}</span> : null}
    </>
  );

  const rightButtonNormal = () => (
    <>
      {props.mobileControls ? <span>{t(`${props.mobileControls.rightText}.string`)}</span> : null}
      <Image className={style.stepperVague_chevronRight} src={chevron} role="presentation" onContextMenu={(e) => { e.preventDefault() }} />
    </>
  );

  const rightButtonDisabled = () => (
    <>
      {props.mobileControls ? <span>{t(`${props.mobileControls.rightText}.string`)}</span> : null}
      <Image
        className={style.stepperVague_chevronRight}
        src={chevronDisabled}
        role="presentation"
        onContextMenu={(e) => { e.preventDefault() }}
      />
    </>
  );

  const timerRight = React.useRef(null);
  const timerLeft = React.useRef(null);
  const [currentVal, setCurrentVal] = React.useState(props.currentValue);
  let counter = 0;
  let currVal = props.currentValue;

  React.useEffect(() => {
    setCurrentVal(props.currentValue);
  }, [props.currentValue]);

  const holdingRight = () => {
    if (currVal === props.max) { clearTimeout(timerRight.current); }
    else {
      if (props.keyboardStep !== "auto") {
        props.onChange(Number((currentVal + props.step + (counter*props.step)).toFixed(6)));
        currVal = Number((currentVal + props.step + (counter*props.step)).toFixed(6));
      }
      else if (props.ariaInterval + counter < props.altTextData.length - 1 && props.altTextData[props.ariaInterval + 1 + counter].keyboardStep !== "") {
        props.onChange(Number((parseFloat(props.altTextData[props.ariaInterval + 1 + counter].keyboardStep)).toFixed(6)));
        currVal = Number((parseFloat(props.altTextData[props.ariaInterval + 1 + counter].keyboardStep)).toFixed(6));
      }
      else { clearTimeout(timerRight.current); }
      counter++;
      if (counter > 25) { timerRight.current = setTimeout(holdingRight, 25); }
      else if (counter > 7) { timerRight.current = setTimeout(holdingRight, 100); }
      else { timerRight.current = setTimeout(holdingRight, 250); }
    }
  };

  const releaseRight = () => {
    counter = 0;
    clearTimeout(timerRight.current);
  };

  const holdingLeft = () => {
    if (currVal === props.min) { clearTimeout(timerLeft.current); }
    else {
      if (props.keyboardStep !== "auto") {
        props.onChange(Number((currentVal - props.step - (counter*props.step)).toFixed(6)));
        currVal = Number((currentVal - props.step - (counter*props.step)).toFixed(6));
      }
      else if (props.keyboardStep === "auto" && props.ariaInterval - counter !== 0 && props.altTextData[props.ariaInterval - 1 - counter].keyboardStep !== "") {
        props.onChange(Number((parseFloat(props.altTextData[props.ariaInterval - 1 - counter].keyboardStep)).toFixed(6)));
        currVal = Number((parseFloat(props.altTextData[props.ariaInterval - 1 - counter].keyboardStep)).toFixed(6));
      }
      else { clearTimeout(timerLeft.current); }
      counter++;
      if (counter > 25) { timerLeft.current = setTimeout(holdingLeft, 25); }
      else if (counter > 7) { timerLeft.current = setTimeout(holdingLeft, 100); }
      else { timerLeft.current = setTimeout(holdingLeft, 250); }
    }
  };

  const releaseLeft = () => {
    counter = 0;
    clearTimeout(timerLeft.current);
  };

  return (
    <>
      <Button
        className={style.stepperVague}
        onMouseDown={holdingLeft} onMouseUp={releaseLeft}
        // onTouchStart={holdingLeft} onTouchEnd={releaseLeft}
        onKeyDown={(e) => {
          if (e.repeat) { return }
          const keycode = (e.keyCode ? e.keyCode : e.which)
          if (keycode === 13) { holdingLeft() }
        }}
        onKeyUp={(e) => {
          const keycode = (e.keyCode ? e.keyCode : e.which)
          if (keycode === 13) { releaseLeft() }
        }}
        disabled={underflow()}
        normalicon={leftButtonNormal()}
        disabledicon={leftButtonDisabled()}
        ariaLabel={t("sliderLeft.string")}
      />
      <input
        className={style.stepperVague_currentValue}
        type="number"
        min={props.min}
        max={props.max}
        step={props.step}
        value={previsional}
        onChange={(e) => { setPrevisional(e.target.value) }}
        onKeyDown={(e) => { if(e.keyCode === 13){validateChange(e.target.value)} }}
      />
      <Button
        className={style.stepperVague}
        onMouseDown={holdingRight} onMouseUp={releaseRight}
        // onTouchStart={holdingRight} onTouchEnd={releaseRight}
        onKeyDown={(e) => {
          if (e.repeat) { return }
          const keycode = (e.keyCode ? e.keyCode : e.which)
          if (keycode === 13) { holdingRight() }
        }}
        onKeyUp={(e) => {
          const keycode = (e.keyCode ? e.keyCode : e.which)
          if (keycode === 13) { releaseRight() }
        }}
        disabled={overflow()}
        normalicon={rightButtonNormal()}
        disabledicon={rightButtonDisabled()}
        ariaLabel={t("sliderRight.string")}
      />
    </>
  );
}

VagueStepper.propTypes = {
  /**
   * lowest value possible
   */
  min: PropTypes.number,
  /**
   * highest value possible
   */
  max: PropTypes.number,
  /**
   * current value
   */
  currentValue: PropTypes.number,
  /**
   * increment/decremnet step
   */
  step: PropTypes.number,
};
